<script lang="ts">
  // Modal admin pra criar torneio. Validações leves no front; backend
  // valida tudo de novo (size potencia de 2, starts_at futuro).
  import { createTournament } from '../../stores/tournaments';

  type Props = { onClose: () => void };
  let { onClose }: Props = $props();

  let size = $state(8);
  let format: '1v1' | '2v2' = $state('2v2');
  let modality: 'paulista' | 'mineiro' = $state('paulista');
  let name = $state('');
  // Default starts_at = agora + 5 min (formato datetime-local)
  let startsAtLocal = $state(defaultStartsAt());
  let buyInReais = $state(0);
  let busy = $state(false);
  let errorMsg = $state<string | null>(null);

  function defaultStartsAt(): string {
    const d = new Date(Date.now() + 5 * 60 * 1000);
    // datetime-local format: YYYY-MM-DDTHH:mm
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  const sizes = [2, 4, 8, 16, 32, 64, 128, 256];

  async function submit() {
    if (busy) return;
    errorMsg = null;
    busy = true;
    const startsAt = new Date(startsAtLocal).toISOString();
    const t = await createTournament({
      modality,
      format,
      size,
      name: name.trim() || undefined,
      starts_at: startsAt,
      buy_in_cents: Math.round(buyInReais * 100),
    });
    busy = false;
    if (t) {
      onClose();
    } else {
      errorMsg = 'erro ao criar torneio — confira os campos';
    }
  }
</script>

<div class="overlay" onclick={onClose} role="presentation">
  <div class="card" onclick={(e) => e.stopPropagation()} role="dialog">
    <h2>Criar Torneio</h2>

    <label>
      <span>Nome (opcional)</span>
      <input type="text" bind:value={name} placeholder="Ex: Friday Night 8" maxlength="60" />
    </label>

    <div class="row">
      <label>
        <span>Tamanho</span>
        <select bind:value={size}>
          {#each sizes as s}
            <option value={s}>{s} players</option>
          {/each}
        </select>
      </label>
      <label>
        <span>Formato</span>
        <select bind:value={format}>
          <option value="2v2">2v2 Duplas</option>
          <option value="1v1">1v1</option>
        </select>
      </label>
    </div>

    <div class="row">
      <label>
        <span>Modalidade</span>
        <select bind:value={modality}>
          <option value="paulista">Paulista</option>
          <option value="mineiro">Mineiro</option>
        </select>
      </label>
      <label>
        <span>Buy-in (R$)</span>
        <input type="number" bind:value={buyInReais} min="0" step="1" />
      </label>
    </div>

    <label>
      <span>Começa em</span>
      <input type="datetime-local" bind:value={startsAtLocal} />
    </label>

    {#if errorMsg}
      <div class="error">{errorMsg}</div>
    {/if}

    <div class="actions">
      <button class="cancel" onclick={onClose} disabled={busy}>cancelar</button>
      <button class="submit" onclick={submit} disabled={busy}>
        {busy ? 'criando...' : 'criar torneio'}
      </button>
    </div>
  </div>
</div>

<style>
  .overlay {
    position: fixed;
    inset: 0;
    z-index: 1100;
    background: rgba(2, 3, 26, 0.85);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }
  .card {
    width: 100%;
    max-width: 420px;
    max-height: calc(100dvh - 32px);
    overflow-y: auto;
    padding: 20px;
    background: var(--bg-elev);
    border: 1px solid rgba(255, 210, 74, 0.5);
    border-radius: var(--radius-lg);
    display: flex;
    flex-direction: column;
    gap: 12px;
    box-shadow: 0 18px 50px rgba(0, 0, 0, 0.7);
  }
  h2 {
    margin: 0 0 4px;
    font-size: 16px;
    letter-spacing: 2px;
    color: var(--warn);
  }
  label {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 12px;
    color: var(--text-dim);
  }
  label span {
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 10px;
  }
  input, select {
    padding: 8px 10px;
    background: rgba(0, 0, 0, 0.35);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    color: var(--text);
    font-size: 13px;
    font-family: inherit;
  }
  input:focus, select:focus {
    outline: none;
    border-color: var(--warn);
  }
  .row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .error {
    color: var(--danger);
    font-size: 12px;
    padding: 8px;
    background: rgba(255, 76, 126, 0.08);
    border-radius: var(--radius-sm);
  }
  .actions {
    display: flex;
    gap: 10px;
    margin-top: 8px;
  }
  .cancel {
    flex: 1;
    background: transparent;
    border: 1px solid var(--border);
    color: var(--text-dim);
  }
  .cancel:hover { color: var(--text); border-color: var(--text-dim); }
  .submit {
    flex: 2;
    background: var(--warn);
    color: #1a1004;
    border: none;
    font-weight: 800;
    letter-spacing: 1.5px;
    text-transform: uppercase;
  }
  .submit:hover { background: #ffe066; }
  .submit:disabled, .cancel:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
</style>
